import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import PageSpinner from '@/components/PageSpinner';
import { Auth0ErrorState } from './components/Errors/Auth0ErrorState';
import useLoginWithConnection from './hooks/initialization/useLoginWithConnection';
import { loggedOut } from './redux/slices/loggedUserSlice';

const UnauthenticatedApp = () => {
  const { error: auth0Error, logout } = useAuth0();
  const { loginWithConnection, connectionRef } = useLoginWithConnection();
  const isEmbedded = window.self !== window.top;

  useEffect(() => {
    if (!auth0Error) {
      // Skip loginWithConnection if we're in an embedded context with a connection param.
      // useDestroyExistingSSOSession handles the initial auth flow for embedded SSO.
      if (isEmbedded && connectionRef.current) {
        return;
      }
      loginWithConnection();
    }
  }, [loginWithConnection, auth0Error, connectionRef, isEmbedded]);

  if (auth0Error) {
    return (
      <Auth0ErrorState
        auth0Error={auth0Error}
        logout={logout}
        loggedOut={loggedOut}
      />
    );
  }

  return <PageSpinner />;
};

export default UnauthenticatedApp;
